export default __webpack_public_path__ + "static/media/plus.c3075f2e.svg";